/** Link ufficiali collegati alla sezione Economia Locale / vetrina territoriale. */
export const SAGRA_PORCHETTA_ITALICA_URL = "https://www.sagradellaporchettaitalica.com/";

/** Storia della sagra sul sito Pro Loco (pagina istituzionale). */
export const SAGRA_PORCHETTA_PRO_LOCO_STORIA_URL =
  "https://www.sagradellaporchettaitalica.com/storia";

export function isExternalHref(href) {
  return typeof href === "string" && (href.startsWith("http://") || href.startsWith("https://"));
}
